import React from "react";
import { Box, Heading, ResponsiveContext, Text } from "grommet";
import { useContext } from "react";
export var SignUpType = function SignUpType(_ref) {
  var setSignUpType = _ref.setSignUpType;
  var size = useContext(ResponsiveContext);
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      background: {
        color: "site-colors-1",
      },
      round: "small",
      pad:
        size === "desktop1400" || size === "desktop1900"
          ? {
              vertical: "30px",
              horizontal: "45px",
            }
          : {
              top: "26px",
              bottom: "20px",
              horizontal: "20px",
            },
    },
    /*#__PURE__*/ React.createElement(
      Box,
      {
        flex: true,
        direction: size === "desktop1400" || size === "desktop1900" ? "row" : "column",
        justify: "between",
        gap: "1rem",
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          background: "black",
          width: "520px",
          style: {
            borderRadius: "10px",
            padding: "20px 25px 30px",
            cursor: "pointer",
          },
          gap: "1rem",
          onClick: function onClick() {
            return setSignUpType("sportsman");
          },
        },
        /*#__PURE__*/ React.createElement(
          Text,
          {
            size: "14px",
            color: "site-colors-4",
          },
          "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043A\u0430\u043A"
        ),
        size === "desktop1400" || size === "desktop1900"
          ? /*#__PURE__*/ React.createElement(
              Heading,
              {
                level: 2,
              },
              "\u0421\u043F\u043E\u0440\u0442\u0441\u043C\u0435\u043D"
            )
          : /*#__PURE__*/ React.createElement(
              Heading,
              {
                level: 3,
                size: "small",
              },
              "\u0421\u043F\u043E\u0440\u0442\u0441\u043C\u0435\u043D"
            )
      ),
      /*#__PURE__*/ React.createElement(
        Box,
        {
          background: "black",
          width: "520px",
          style: {
            borderRadius: "10px",
            padding: "20px 25px 30px",
            cursor: "pointer",
          },
          gap: "1rem",
          onClick: function onClick() {
            return setSignUpType("organization");
          },
        },
        /*#__PURE__*/ React.createElement(
          Text,
          {
            size: "14px",
            color: "site-colors-4",
          },
          "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043A\u0430\u043A"
        ),
        size === "desktop1400" || size === "desktop1900"
          ? /*#__PURE__*/ React.createElement(
              Heading,
              {
                level: 2,
              },
              "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440"
            )
          : /*#__PURE__*/ React.createElement(
              Heading,
              {
                level: 3,
                size: "small",
              },
              "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440"
            )
      )
    )
  );
};
